// Rerences: https://react.dev/learn/passing-data-deeply-with-context
import { createContext } from 'react';

export const GlobalStateContext = createContext();
